import React, { useState, useEffect, useRef, useCallback } from "react";
import Geocode from "react-geocode";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import { GOOGLE_MAP_API_KEY } from "../../../Config/helpers/constants";

const MapWithAMarker = withScriptjs(
  withGoogleMap(({ center, onDragEnd, onZoomChanged, mapRef }) => (
    <GoogleMap ref={mapRef} defaultZoom={8} defaultCenter={{ lat: 33.738045, lng: 73.084488 }}>
      <Marker
        position={{ lat: center?.latitude, lng: center?.longitude }}
        onZoomChanged={onZoomChanged}
        draggable={true}
        onDragEnd={onDragEnd}
      />
    </GoogleMap>
  ))
);

const MapCard = ({ setCoordinate, setLocation, data = {}, padding }) => {
  const mapRef = useRef(null);
  const [center, setCenter] = useState({ latitude: 33.738045, longitude: 73.084488 });

  useEffect(() => {
    Geocode.setApiKey(GOOGLE_MAP_API_KEY);
    Geocode.enableDebug();

    if (data?.coordinate?.latitude && data?.coordinate?.longitude) {
      setCenter({
        latitude: data.coordinate.latitude,
        longitude: data.coordinate.longitude
      });
    }
  }, [data?.coordinate?.latitude, data?.coordinate?.longitude]);

  const handleDragEnd = useCallback(
    (ev) => {
      const lat = ev.latLng.lat();
      const lng = ev.latLng.lng();

      Geocode.fromLatLng(lat, lng).then(
        (response) => {
          const address = response.results[0].formatted_address;
          if (setLocation) {
            setLocation(address);
          }
        },
        (error) => {
          console.error(error);
        }
      );

      setCenter({ latitude: lat, longitude: lng });

      if (setCoordinate) {
        setCoordinate({ latitude: lat, longitude: lng });
      }
    },
    [setCoordinate, setLocation]
  );

  const handleZoomChanged = useCallback(() => {
    if (mapRef.current) {
      // const zoom = mapRef.current.getZoom();
    }
  }, []);

  return (
    <div style={{ height: "260px", width: "100%", padding: !padding ? "3%" : undefined }}>
      <MapWithAMarker
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `260px`, padding: "3% 0", borderRadius: "8px" }} />}
        mapElement={<div style={{ height: `100%`, borderRadius: "8px" }} />}
        center={center}
        onDragEnd={handleDragEnd}
        onZoomChanged={handleZoomChanged}
        mapRef={mapRef}
      />
    </div>
  );
};

export default MapCard;
